const routes = {
  HOME: `/`,
  FORM_DEFINITIONS: `/form-definitions`,
  FORM_DEFINITION_EDIT: `/form-definitions/:formDefinitionId`,
  FORM_DEFINITION_PREVIEW: `/form-definitions/:formDefinitionId/preview`,
  RESOURCES: `/resources`,
};

export default routes;
